import * as variables from './variables.js';

// NOTE: Gallery must see jQuery on the window in order to work properly
// NOTE: Colorbox must see jQuery on the window in order to work properly
import * as $ from 'jquery';
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import './lib/AnimationEasing';

import DialogUtils from './lib/DialogUtils';
DialogUtils.attachColorboxAriaRoles();

// import { Analytics } from '@plaudit/analytics';
// Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
// menuTriggers: '.menuToggle--open, .menuToggle--close, .pageOverlay',
new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuToggle, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 145,
	scrollDistanceUp: 20
});


/* Collapable Groups */
import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup({
	container: '.productAdditionalInfo',
	item: '.panel',
	trigger: 'button',
	target: '.panel__text',
	defaultIndex: 0
});
new CollapsableGroup({
	container: '.comment[data-replies]',
	item: '.comment',
	trigger: '.comment__viewReplies',
	target: '.comment__replies',
	defaultIndex: -1
});


import Forms from './component/Forms';
Forms.init();


import Gallery from './component/Gallery';
new Gallery();

/* Sets up stars? */
import WriteReview from './component/WriteReview/WriteReview';
new WriteReview().init();

/* write a review */
(function () {
	let showHiddenElements = document.querySelectorAll('a[href*="#writeReview"]');
	if (showHiddenElements) {
		for (let i = 0, l = showHiddenElements.length; i < l; i++) {
			const target = document.getElementById((<HTMLAnchorElement>showHiddenElements[i]).hash.substring(1));
			target.setAttribute('data-hidden', 'hidden');

			(showHiddenElements[i]).setAttribute('aria-controls', 'writeReview');
			(showHiddenElements[i]).setAttribute('aria-expanded', 'false');
			(showHiddenElements[i]).addEventListener("click", (event) => {
				event.preventDefault();
				const anchor = <HTMLAnchorElement>event.currentTarget;
				let isExpanded = anchor.getAttribute('aria-expanded') === 'true';
				document.getElementById(anchor.hash.substring(1)).setAttribute('data-hidden', (isExpanded ? 'hidden' : 'visible'));
				anchor.setAttribute('aria-expanded', (isExpanded ? 'false' : 'true'));
			})
		}
	}
})();

/* sticky menu */
(function () {
	if ('IntersectionObserver' in window) {
		let observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					entry.target.removeAttribute('data-sticky');
				} else {
					entry.target.setAttribute('data-sticky', 'true');
				}
			});
		});

		let entriesArray = [].slice.call(document.querySelectorAll('#menu .menu'));
		entriesArray.forEach((entry: any) => {
			observer.observe(entry);
		});
	}
})();

import Product from './component/Product';
new Product();


const focusLock = function(){
	const dialog = document.querySelector('[role="dialog"]');
	if (dialog){
		const firstFocusableElement: HTMLElement = dialog.querySelector('.first-focusable-element');
		const lastFocusableElement: HTMLElement = dialog.querySelector('.last-focusable-element');

		dialog.addEventListener('keydown', function (event: KeyboardEvent) {
			if (event.target == firstFocusableElement && event.key == 'Tab' && event.shiftKey) {
				event.preventDefault();
				lastFocusableElement.focus();
			} else if (event.target == lastFocusableElement && event.key == 'Tab' && !event.shiftKey) {
				event.preventDefault();
				firstFocusableElement.focus();
			}
		});
	}
}
focusLock();


// NOTE: this is gross, but works
function makeMyCartModal(){
	// console.log('makeMyCartModal');
	let fc = document.getElementById('fc');
	if (!fc) return;

	fc.setAttribute('aria-modal', 'true');
	fc.setAttribute('role', 'dialog');
	fc.setAttribute('aria-label', 'Your Cart');

	fc.querySelector('[role="button"]').classList.add('first-focusable-element');
	fc.querySelector('.fc-action--checkout--button').classList.add('last-focusable-element');
	// makes first focusable actually focusable
	let first: HTMLElement = fc.querySelector('[role="button"]:not([href])');
	if (first){
		first.setAttribute('href', '#cartToggle');
		first.focus();
	}

	DialogUtils.focusLock( fc );
}

let returnFocusTo:HTMLElement;

interface FCClient {
	on(event: string, callback: (params: { element: HTMLElement }, next: () => void) => void): void;
}

declare const FC: {
	onLoad: () => void;
	client: FCClient;
};

FC.onLoad = function () {
	FC.client.on('sidecart-show', function (params, next) {
		returnFocusTo = params.element;
		returnFocusTo.setAttribute('id','cartToggle');
		next();
	});
	FC.client.on('sidecart-detach', function (params, next) {
		if (!returnFocusTo){ return; }
		returnFocusTo.focus();
	});
	FC.client.on('render.done', function (params, next) {
		makeMyCartModal();
		next();
	});
};

// form augmentation
function addMissingIds(){
	let forms = (document.getElementsByTagName('form'));
	for (let i = 0, l=forms.length;i<l;i++){
		for (let ii = 0, ll=(forms[i]).elements.length;ii<ll;ii++){
			let field = (forms[i]).elements[ii];
			if ( (field.getAttribute('type') !== "hidden") && !field.getAttribute('id') && field.getAttribute('name')){
				field.setAttribute('id', field.getAttribute('name'));
			}
		}
	}
}
const zipCodeObserver = new MutationObserver(function() {
	focusOnShippingPostalCode();
});
function cofigureChangeShippingLocationButton() {
	let button = document.querySelector('[data-fc-id="change-shipping-location-button"]');
	// Early exit
	if (!button || (button && button.hasAttribute('data-init'))) {
		return;
	}
	button.setAttribute('data-init', 'true');
	button.addEventListener('click', function () {
		if (!focusOnShippingPostalCode()) {
			zipCodeObserver.observe(document.getElementById('fc-cart-form'), {subtree: true, childList: true});
		}
	});
}
function focusOnShippingPostalCode() {
	let field = document.getElementById('shipping_postal_code');
	if (field) {
		field.focus();
		zipCodeObserver.disconnect();
		return true;
	} else {
		return false;
	}
}
new MutationObserver(() => {
	addMissingIds();
	cofigureChangeShippingLocationButton();
}).observe(document, {subtree: true, childList: true});

